'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'compress';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f066';
var svgPathData = 'M160 48l0-16-32 0 0 128-128 0 0 32 160 0 0-144zM16 320l-16 0 0 32 128 0 0 128 32 0 0-160-144 0zM320 48l0-16-32 0 0 160 160 0 0-32-128 0 0-112zM304 320l-16 0 0 160 32 0 0-128 128 0 0-32-144 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCompress = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;